import { DOCUMENT, Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import {
  SuiModal,
  ComponentModalConfig,
  ModalSize,
  SuiModalService,
} from '@richardlt/ng2-semantic-ui';
import { OrganizationService } from 'src/modules/features/admin/services';

interface IEditCompanyCeoInfoModalContext {
  title: string;
  data?: any;
}

@Component({
  selector: 'app-edit-company-ceo-info-modal',
  templateUrl: './edit-company-ceo-info-modal.component.html',
  styleUrls: ['./edit-company-ceo-info-modal.component.scss'],
})
export class EditCompanyCeoInfoModalComponent implements OnInit {
  pending: boolean;
  successMsg;
  errorMsg: any;
  extraData;

  formSubmitAttempt: boolean;
  companyCEOForm: FormGroup;

  roles: string[] = [];

  organizations: string[] = [];

  showPassword: boolean = false;
  showConfirmPassword: boolean = false;

  constructor(
    private fb: FormBuilder,
    @Inject(DOCUMENT) private document,
    public modal: SuiModal<IEditCompanyCeoInfoModalContext, void, void>,
    private http: HttpClient,
    private modalService: SuiModalService,
    private organizationSvc: OrganizationService
  ) {
    this.extraData = this.modal.context.data;
    console.log(this.extraData);

    this.companyCEOForm = fb.group({
      ceoName: ['', Validators.required],
      ceoContactEmail: ['', [Validators.required, Validators.email]],
      ceoContactPhone: ['', Validators.required],
    });
    this.companyCEOForm.patchValue(this.extraData);
  }

  ngOnInit(): void {
    // this.document.body.classList.add('panel');
  }

  /**
   * @author Mariam
   * @dateCreated 2 Sep 2023
   * @description Determines if a form field is valid or not. It checks if the field is touched and invalid or untouched and the form has been submitted
   * @param field A string representing the name of the form field to be checked.
   * @returns A boolean value indicating if the form field is valid or not.
   */
  isFieldValid(field: string) {
    return (
      (!this.companyCEOForm.get(field).valid &&
        this.companyCEOForm.get(field).touched) ||
      (this.companyCEOForm.get(field).untouched && this.formSubmitAttempt)
    );
  }

  /**
   * @author Mariam
   * @dateCreated 2 Sep 2023
   * @description Determines the CSS class to be applied to a form field based on its validity status.
   * @param field A string representing the name of the form field to be checked.
   * @returns An object with the 'error' property set to true or false.
   */
  displayFieldCss(field: string) {
    return {
      error: this.isFieldValid(field),
    };
  }

  /**
   * @author Mariam
   * @dateCreated 2 Sep 2023
   * @description Updates user account based on the provided user object.
   * @returns {void}
   * @modifiedBy
   * @dateModified -
   */
  update() {
    this.pending = false;
    if (this.companyCEOForm.valid) {
      this.errorMsg = null;
      this.pending = true;
      this.successMsg = null;

      if (this.modal.context.data) {
        this.organizationSvc
          .addCEODetails({
            nccId: this.modal.context.data.nccId,
            body: this.companyCEOForm.value,
          })
          .subscribe({
            next: () => {
              this.pending = false;
              this.successMsg = 'CEO Information Updated';
              setTimeout(() => this.modal.approve(), 500);
              this.companyCEOForm.reset();
              window.location.reload();
            },
            error: (error: any) => {
              this.errorMsg = error?.error?.message
                ? error?.error?.message
                : error;
              this.pending = false;
            },
          });
      }
    }
  }

  ngOnDestroy(): void {
    // this.document.body.classList.remove('panel');
  }
}

export class EditCompanyCeoInfoModal extends ComponentModalConfig<
  IEditCompanyCeoInfoModalContext,
  void,
  void
> {
  constructor(title: string, data: any, size: ModalSize = ModalSize.Mini) {
    super(EditCompanyCeoInfoModalComponent, { title, data });

    this.isCentered = false;
    this.isClosable = false;
    this.transition = 'slide left';
    this.transitionDuration = 200;
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
